module.exports = __webpack_public_path__ + "static/media/Community3.e0403a6b.png";